<template>
  <div class="form-card">
    <main class="form-protocol" v-if="!hasAgreed">
      <div class="form-protocol_title">申请须知</div>
      <div class="form-protocol_subtitle">核心声明</div>
      <ol>
        <li
          >1. 本报名入口为<span class="fc-red">学校层面专属申请通道</span
          >，仅面向具备正式办学资质、计划组织学生参与竞赛的学校，不接受学生个人、教师个人单独申请。</li
        >
        <li
          >2.
          申请人需为学校官方授权代表（如教务处负责人、数学教研组组长等），提交申请即代表学校作出正式承诺：所填信息、后续提交的名单均真实有效，且学校已充分了解竞赛相关要求并愿意遵守。</li
        >
        <li
          >3.
          若存在以下情况，将永久拉黑学校及相关申请人，取消后续所有竞赛申请资格：
          <ul>
            <li>非学校官方授权人员虚假申请、冒用学校名义申请；</li>
            <li>申请信息填写虚假、不完整，经提醒后仍未补正；</li>
            <li
              >多次提交无效申请（如重复申请、信息混乱无明确意向），干扰审核秩序。</li
            >
          </ul>
        </li>
      </ol>
      <div class="form-protocol_subtitle">申请流程</div>
      <ol>
        <li
          >1. 申请人通过官网 “我要报名”
          入口，按要求填写学校基本信息（学校名称、联系人、联系电话、申请理由等）；</li
        >
        <li>2. 提交申请后，等待初步审核；</li>
        <li
          >3. 申请结果会进行邮件通知，若初审通过，官网将同步开放师生名单 Excel
          模板及提交通道；</li
        >
        <li
          >4.
          申请人按模板要求整理师生名单并提交，经核查材料符合要求后，将为对应师生开通竞赛相关权益；</li
        >
        <li
          >5. 权益开通后，申请人将收到邮件通知：<span class="fc-red"
            >学生可凭指定账号登录官网参与考试，教师可登录系统进行试卷批改</span
          >；同时，<span class="fc-red"
            >会给出运营老师微信，请申请人及时添加</span
          >，我们将邀请您加入专属微信沟通群，后续相关事宜通过群内同步。</li
        >
      </ol>
      <div class="form-protocol_subtitle">审核周期</div>
      <ol>
        <li
          >1.总审核周期约为15个工作日（自申请材料完整提交之日起计算）；申请材料提交后，可通过官网报名入口查看审核状态，无需重复提交申请；</li
        >
        <li
          >2.审核结果将通过官网、预留邮箱同步通知，未通过审核的将说明具体原因，可在补充完善材料后重新申请</li
        >
      </ol>

      <div class="form-protocol_agree">
        <input
          type="checkbox"
          v-model="agreedCheck"
          id="agreedCheck"
          class="agree-check"
        />
        <label for="agreedCheck">
          <div class="step-iconWrap">
            <img
              src="https://pandapub.nosdn.127.net/tmp1763002681_ltnon6bsdwqvdloznivmoa%3D%3D_2_1762999081_0.png"
              class="step-icon"
            /> </div
          >点击即表示您已理解并接受本须知的全部条款。</label
        >
      </div>

      <footer class="form-protocol_footer">
        <!-- <button class="button btn-cancel" @click="handleCancel">取消</button> -->
        <button
          class="button btn-submit"
          :disabled="!agreedCheck"
          @click="handleStart"
          >开始申请</button
        >
      </footer>
    </main>
    <div class="form-main" v-else>
      <h1 class="form-main_title">基本信息</h1>

      <div class="form-main_content">
        <el-form
          ref="attendForm"
          :model="form"
          :rules="formRules"
          label-width="140px"
          class="attend-form"
        >
          <el-form-item label="学校名称（全称）" prop="schoolName">
            <el-input
              v-model.trim="form.schoolName"
              placeholder="如：浙江大学附属中学"
              maxlength="100"
              clearable
            />
          </el-form-item>

          <el-form-item label="学校类型" prop="schoolType">
            <el-select
              v-model="form.schoolType"
              placeholder="请选择您的学校类型"
            >
              <el-option
                v-for="item in schoolTypeList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="form.schoolType === 'OTHER'"
            label=""
            prop="schoolTypeOther"
          >
            <el-input v-model="form.schoolTypeOther" maxlength="50"></el-input>
          </el-form-item>

          <el-form-item label="所在地区" prop="address">
            <el-cascader
              v-model="form.address"
              placeholder="请选择学校所在地区"
              :options="district"
              filterable
            ></el-cascader>
          </el-form-item>

          <el-form-item label="联系人姓名" prop="contactName">
            <el-input
              v-model.trim="form.contactName"
              placeholder="请输入您的姓名"
              maxlength="50"
              clearable
            />
          </el-form-item>

          <el-form-item label="联系微信" prop="contactWechat">
            <el-input
              v-model.trim="form.contactWechat"
              placeholder="申请通过后，会通过微信邀请您进入官方沟通群"
              maxlength="50"
              clearable
            />
          </el-form-item>

          <el-form-item label="联系电话" prop="contactPhone">
            <el-input
              v-model.trim="form.contactPhone"
              placeholder="请输入您的联系方式"
              maxlength="20"
              clearable
            />
          </el-form-item>

          <el-form-item label="联系邮箱" prop="contactEmail">
            <el-input
              v-model.trim="form.contactEmail"
              placeholder="请输入您的常用的邮箱"
              maxlength="64"
              clearable
            />
          </el-form-item>

          <el-form-item label="学校官网" prop="schoolWebsite">
            <el-input
              v-model="form.schoolWebsite"
              placeholder="选填，填写学校官网或对外公示平台"
              maxlength="200"
              clearable
            />
          </el-form-item>
          <el-form-item label="申请理由" prop="applicationReason">
            <el-input
              v-model="form.applicationReason"
              type="textarea"
              :rows="4"
              placeholder="请详细描述申请理由，以及期望的合作形式"
              maxlength="1000"
              show-word-limit
              resize="vertical"
            />
          </el-form-item>

          <footer class="form-main_footer">
            <!-- <div class="button btn-cancel" @click="handleCancel">取消</div> -->
            <div
              type="primary"
              class="button btn-submit"
              :loading="isLoading"
              :disabled="isLoading"
              @click="handleSubmit"
            >
              {{ isLoading ? '提交中...' : '提交' }}
            </div>
          </footer>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { Form, FormItem, Select, Option, Input, Cascader } from 'element-ui';
  import district from '@/common/js/district';

  export default {
    name: 'SchoolApplicationForm',
    props: {
      loading: {
        type: Boolean,
        default: false,
      },
      hasAgreed: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      'el-form': Form,
      'el-form-item': FormItem,
      'el-select': Select,
      'el-option': Option,
      'el-input': Input,
      'el-cascader': Cascader,
    },
    data() {
      // 手机号验证规则
      const validatePhone = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入联系电话'));
        } else {
          const phoneReg = /^1[3-9]\d{9}$/;
          if (!phoneReg.test(value)) {
            callback(new Error('请输入正确的手机号码'));
          } else {
            callback();
          }
        }
      };

      // 邮箱验证规则
      const validateEmail = (rule, value, callback) => {
        if (!value) {
          callback(new Error('请输入邮箱'));
        } else {
          const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          if (!emailReg.test(value)) {
            callback(new Error('请输入正确的邮箱地址'));
          } else {
            callback();
          }
        }
      };

      return {
        district,
        agreedCheck: false,
        form: {
          schoolName: '',
          schoolType: '',
          schoolTypeOther: '',
          address: [],
          schoolWebsite: '',
          contactName: '',
          contactPhone: '',
          contactEmail: '',
          applicationReason: '',
        },
        formRules: {
          schoolName: [
            { required: true, message: '请输入学校名称', trigger: 'blur' },
            { max: 100, message: '学校名称不能超过100个字符', trigger: 'blur' },
          ],
          address: [
            { required: true, message: '请选择学校所在地区', trigger: 'blur', type: 'array' },
          ],
          schoolType: [
            { required: true, message: '请选择学校类型', trigger: 'blur' },
          ],
          schoolTypeOther: [
            { required: true, message: '请输入学校类型', trigger: 'blur' },
          ],
          contactName: [
            { required: true, message: '请输入联系人姓名', trigger: 'blur' },
            { max: 50, message: '联系人姓名不能超过50个字符', trigger: 'blur' },
          ],
          contactWechat: [
            { required: true, message: '请输入联系微信', trigger: 'blur' },
            { max: 100, message: '联系微信不能超过100个字符', trigger: 'blur' },
          ],
          contactPhone: [
            { required: true, validator: validatePhone, trigger: 'blur' },
            { max: 20, message: '联系电话不能超过20个字符', trigger: 'blur' },
          ],
          contactEmail: [
            { required: true, validator: validateEmail, trigger: 'blur' },
            { max: 100, message: '邮箱不能超过100个字符', trigger: 'blur' },
          ],
          applicationReason: [
            { required: true, message: '请输入申请理由', trigger: 'blur' },
            {
              max: 1000,
              message: '学校简介不能超过1000个字符',
              trigger: 'blur',
            },
          ],
        },
        // 小学(PRIMARY)、初中(JUNIOR_HIGH)、高中(SENIOR_HIGH)、一贯制学校(CONSISTENT)、其他(OTHER)
        schoolTypeList: [
          { value: 'PRIMARY', label: '小学' },
          { value: 'JUNIOR_HIGH', label: '初中' },
          { value: 'SENIOR_HIGH', label: '高中' },
          { value: 'CONSISTENT', label: '一贯制学校' },
          { value: 'OTHER', label: '其他' },
        ],
      };
    },
    computed: {
      isLoading: {
        get() {
          return this.loading;
        },
        set(value) {
          this.$emit('update:loading', value);
        },
      },
    },
    methods: {
      handleCancel() {
        this.$emit('cancel');
      },
      handleStart() {
        this.$emit('update:hasAgreed', true);
      },
      // 对外提供的提交方法
      submitForm() {
        return new Promise((resolve, reject) => {
          this.$refs.attendForm.validate(async (valid) => {
            if (!valid) {
              reject(new Error('表单验证失败'));
              return;
            }
            resolve(this.form);
          });
        });
      },
      // 处理提交按钮点击
      handleSubmit() {
        console.log('formData', this.form)
        this.submitForm()
          .then((formData) => {
            const data = {
              ...formData,
              province: formData.address[0],
              city: formData.address[1],
              district: formData.address[2],
            }
            // console.log(data);
            this.$emit('submit', data);
          })
          .catch(() => {
            // 验证失败，不做处理
          });
      },
    },
  };
</script>

<style scoped lang="less">
  .form-card {
    width: 100%;
    .btn-cancel,
    .btn-submit {
      width: 240px;
      font-size: 16px;
    }
    .btn-cancel {
      background-color: #f2f3f5;
      color: #1d2129;
    }
    .btn-submit {
      background-color: #e60012;
      &.disabled,
      &:disabled {
        background-color: #f1acb1;
        cursor: not-allowed;
      }
    }
    .form-protocol {
      text-align: left;
      color: #4e5969;
      font-size: 14px;
      line-height: 1.5;
      &_title {
        text-align: center;
        color: #000000e5;
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 36px;
      }
      &_subtitle {
        color: #000000;
        font-weight: 500;
        margin-bottom: 12px;
        &:nth-child(n + 2) {
          margin-top: 24px;
        }
      }
      &_footer {
        margin-top: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 36px;
      }
      &_agree {
        margin-top: 48px;
        font-size: 13px;
        color: #4e5969;
        user-select: none;
        .step-iconWrap {
          width: 14px;
          height: 14px;
          margin-right: 6px;
          border-radius: 50%;
          background: #cccccc;
          padding: 1px 3px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: center;
          .step-icon {
            width: 100%;
          }
        }
        .agree-check {
          display: none;
          & + label {
            display: flex;
            align-items: center;
          }
          &:checked + label .step-iconWrap {
            background: #e60012;
          }
        }
      }
    }
    .form-main_title {
    }

    .page-title {
      font-size: 32px;
      font-weight: 600;
      color: #1d2129;
      margin-bottom: 12px;
      text-align: center;
    }

    .page-desc {
      font-size: 16px;
      color: #86909c;
      margin-bottom: 40px;
      text-align: center;
    }

    .form-main {
      &_title {
        width: 140px;
        padding-right: 12px;
        box-sizing: border-box;
        font-weight: 500;
        font-size: 18px;
        color: #000000e5;
        text-align: right;
        margin-bottom: 16px;
      }
      &_footer {
        margin-top: 68px;
        display: flex;
        justify-content: center;
        align-items: center;
        column-gap: 36px;
      }
    }
    .form-main_content {
      .attend-form {
        /deep/ .el-form-item__label {
          font-size: 14px;
          font-weight: 500;
          color: #000000e5;
        }

        /deep/ .el-select, .el-cascader {
          width: 100%;
        }

        /deep/ .el-input__inner,
        /deep/ .el-textarea__inner {
          padding: 16px 12px;
          font-size: 14px;
          color: #1d2129;
          transition: all 0.3s;
          box-sizing: border-box;
          font-family: inherit;

          // &:hover {
          //   border-color: #c5111f;
          // }

          // &:focus {
          //   border-color: #e60012;
          //   box-shadow: 0 0 0 2px rgba(230, 0, 18, 0.1);
          // }

          &::placeholder {
            color: #7d8087;
          }
        }

        /deep/ .el-textarea__inner {
          min-height: 100px;
          line-height: 1.5;
          resize: vertical;
        }

        /deep/ .el-input__suffix {
          right: 10px;
        }

        /deep/ .el-input__count {
          color: #999999;
          font-size: 12px;
        }

        /deep/ .el-form-item__error {
          font-size: 12px;
          color: #e60012;
        }

        .submit-btn {
          width: 100%;
          height: 56px;
          font-size: 18px;
          font-weight: 600;
          background: #e60012;
          border-color: #e60012;
          border-radius: 12px;
          transition: all 0.3s;

          &:hover:not(.is-disabled) {
            background: #c5111f;
            border-color: #c5111f;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(230, 0, 18, 0.3);
          }

          &:active:not(.is-disabled) {
            transform: translateY(0);
            background: #b0121a;
            border-color: #b0121a;
          }

          &.is-disabled {
            background: #c9cdd4;
            border-color: #c9cdd4;
            transform: none;
            box-shadow: none;
          }
        }
      }
    }
  }

  /* 响应式设计 */
  @media screen and (max-width: 768px) {
    .form-card {
      padding: 40px 24px;

      .page-title {
        font-size: 24px;
      }

      .form-content {
        .attend-form {
          /deep/ .el-form-item__label {
            font-size: 14px;
          }

          /deep/ .el-input__inner,
          /deep/ .el-textarea__inner {
            font-size: 14px;
            padding: 12px 16px;
          }
        }
      }
    }
  }
</style>
